define('../app/fukit/configuration/error.configuration',['require','exports','module','bluebird','datakit/datakit','../config'],function(require, exports, module) {
  //prettier-ignore
  var Promise = require('bluebird'),
      DataKit = require('datakit/datakit'),
      config  = require('../config');

  if (config.get('LONG_STACK_TRACES')) {
    Promise.longStackTraces();
  }

  var ErrorConfiguration = {
    radioEvents: {
      'app configure': 'onAppConfigure',
    },

    showErrorMessage: function(e) {
      // implement how to show error messages
    },

    logErrorMessage: function(e) {
      if (!config.get('LOG_ERRORS')) {
        return;
      }
      if (e.stack) {
        console.error(e.stack);
      } else {
        console.error(e);
      }
    },

    onAppConfigure: function(app) {
      var self = this;

      // NOTE: event name is all lower case as per DOM convention
      window.addEventListener('unhandledrejection', function(e) {
        // NOTE: e.preventDefault() must be manually called to prevent the default
        // action which is currently to log the stack trace to console.warn
        e.preventDefault();
        // NOTE: parameters are properties of the event detail property
        //prettier-ignore
        var error   = e.detail ? e.detail.reason : e.reason,
            promise = e.detail ? e.detail.promise: e.promise;

        var ignored = error instanceof DataKit.Ajax.AbortError;

        // See Promise.onPossiblyUnhandledRejection for parameter documentation

        if (error && !ignored) {
          self.showErrorMessage(error);
          self.logErrorMessage(error);
        }
      });

      // NOTE: event name is all lower case as per DOM convention
      window.addEventListener('rejectionhandled', function(e) {
        // NOTE: e.preventDefault() must be manually called prevent the default
        // action which is currently unset (but might be set to something in the future)
        e.preventDefault();
        // NOTE: parameters are properties of the event detail property
        var promise = e.detail.promise;
        // See Promise.onUnhandledRejectionHandled for parameter documentation
      });
    },
  };
  module.exports = ErrorConfiguration;
});

